import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import bpAdmin from '../../../../../assets/data/bpAdmin.json'
import { MaintenanceMode } from '../../../../containers/MaintenanceMode/MaintenanceMode'
import { Responsive } from '../../../../containers/Responsive/Responsive'
import { Workspace } from '../../../../containers/Workspace/Workspace'
import queryString from 'query-string'
import { appConfig } from '../../common/constants'
import { SVGInjector } from '@tanem/svg-injector'
import DesktopView from '../DesktopView'
import TabletView from '../TabletView'
import MobileView from '../MobileView'
import { AboutModal } from '../../components'
import TopNav from '../../../../legacy/containers/TopNav'
import { MessageSection } from '../../../../legacy/components/MessageSection'
import { fieldUpdateSettingsAction } from '../../../../legacy/utils/slices'
import AppLogo from '../../../../containers/TopNavigation/components/AppLogo'
import PrintView from '../PrintView/PrintView.container'

const PageView = () => {
  const dispatch = useDispatch()

  const search = window.location.search
  const params = search ? queryString.parse(window.location.search) : {}
  const appConfigExtend = Object.assign({}, appConfig, { params: params })

  const { status } = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)
  const isValid =
    !status.isLoading &&
    !status.isError &&
    status.msgLevel !== 'error' &&
    !staticData.status.isLoading &&
    !staticData.status.isError

  useEffect(() => {
    const mySVGsToInject = document.querySelectorAll('img.injectSVG')
    SVGInjector(mySVGsToInject)

    document.documentElement.classList.add(appConfig.productThemeClasses)

    const itemName = 'sst_bp_' + appConfig.appCode + '_settings' // e.g. 'sst_bp_PBS_settings', 'sst_bp_ACE_settings'
    const settingJson = localStorage.getItem(itemName)
    const savedSetting = JSON.parse(settingJson)
    document.documentElement.classList.remove(
      '-densityCompact',
      '-densityDefault',
      'vertical',
      'horizontal',
    )
    document.documentElement.classList.add(
      savedSetting.fontSize,
      savedSetting.orientation,
      '-themeLight',
    )

    dispatch(
      fieldUpdateSettingsAction({
        orientation: savedSetting.orientation,
        fontSize: savedSetting.fontSize,
      }),
    )
  }, []) // one time only

  return (
    <>
      <TopNav
        branding={<AppLogo appCode={appConfigExtend.appCode} logoUrl={appConfigExtend.logoUrl} />}
        about={AboutModal}
        print={PrintView}
        appConfig={appConfigExtend}
        downloadProps={{
          disabled: !isValid,
        }}
      />

      {bpAdmin && bpAdmin.applications[appConfigExtend.appCode] === 'off' ? (
        <MaintenanceMode appCode={appConfigExtend.appCode} appName={appConfigExtend.appName} />
      ) : (
        <Workspace>
          <MessageSection />

          <Responsive.Desktop>
            <DesktopView />
          </Responsive.Desktop>

          <Responsive.Tablet>
            <TabletView />
          </Responsive.Tablet>

          <Responsive.Mobile>
            <MobileView />
          </Responsive.Mobile>
        </Workspace>
      )}
    </>
  )
}

export default PageView
